import { TUseTranslationTfn } from "../data/AppType";
import { dateFormat, getLocalDate, timeFormat } from "./AppFunctions";
import { DATE_FORMAT } from "./AppEnumerations";
import { CURRENCY_SIGN } from "./AppConstants";
import { formatRupees } from "./PriceCalculator";

const groupDigits = (value: number): string =>
  Math.abs(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const formatPurchaseDate = (date: string | Date | null | undefined): string =>
  date ? dateFormat(date, DATE_FORMAT["DD-MM-YYYY"]) : "-";

export const formatPurchaseDateTime = (
  date: string | Date | null | undefined,
): string =>
  date ? `${formatPurchaseDate(date)} ${timeFormat(getLocalDate(date))}` : "-";

export const formatPurchaseTime = (date: string | Date | null | undefined): string =>
  date ? timeFormat(getLocalDate(date)) : "-";

export const formatCredits = (
  t: TUseTranslationTfn,
  value: number | null | undefined,
): string => {
  if (value === null) return t("unlimited");
  if (value === undefined) return "0";
  return `${value < 0 ? "-" : ""}${groupDigits(value)}`;
};

export const formatCreditDelta = (delta: number | null): string => {
  if (delta === null) return "-";
  return `${delta > 0 ? "+" : delta < 0 ? "-" : ""}${groupDigits(delta)}`;
};

export const dayStartUtc = (day: string | null): string | null =>
  day ? new Date(`${day}T00:00:00`).toISOString() : null;

export const dayEndUtc = (day: string | null): string | null =>
  day ? new Date(`${day}T23:59:59.999`).toISOString() : null;

export const formatAmountWithSign = (value: string | number | null | undefined): string =>
  `${CURRENCY_SIGN} ${formatRupees(value)}`;
